// Candidate profile completeness — single source (mirrors the required-field set
// used by IncompleteProfileBanner). Used by the Home + the profile summary card.

export interface ProfileCompletion {
    percent: number;
    missing: string[];
    complete: boolean;
}

// hasCv is passed in rather than read from the profile because the CV is a
// Document (entity_type=candidate_profile), not a profile column.
export function candidateProfileCompletion(p: any, hasCv = false): ProfileCompletion {
    if (!p) return { percent: 0, missing: [], complete: false };
    // #359 — university + education dropped from the required set. Signup stopped
    // collecting education in #298, so requiring it here marked every candidate who
    // signed up afterwards as permanently incomplete, and IncompleteProfileBanner
    // nagged them to fill a field no form offered. The three below are exactly what
    // the signup journey collects (Hours → Date → Location), so a finished signup
    // now means a finished profile.
    const checks: Array<[boolean, string]> = [
        [!!p.min_hours_per_week && !!p.max_hours_per_week, 'Arbetstimmar'],
        [!!p.available_from_date, 'Tillgänglighetsdatum'],
        [!!p.location, 'Plats'],
        // #359 — the CV counts. It is NOT required to use the app or to apply for
        // a job, and nothing here gates anything; this is a nudge. But calling a
        // profile "komplett" while the single thing an employer actually reads is
        // missing told candidates they were done and cost them the discovery that
        // uploading a CV is even possible.
        [hasCv, 'CV'],
    ];
    const done = checks.filter(([ok]) => ok).length;
    const percent = Math.round((done / checks.length) * 100);
    return {
        percent,
        missing: checks.filter(([ok]) => !ok).map(([, label]) => label),
        complete: percent === 100,
    };
}
